export interface DataPrepGenerateOptions {
  underground: boolean;
  leadins: boolean;
}

type GenerateMode = "generate" | "skip";

export interface DataPrepRunParameters {
  Underground: GenerateMode;
  Leadins: GenerateMode;
}

export const toDataPrepRunParameters = ({ underground, leadins }: DataPrepGenerateOptions): DataPrepRunParameters => ({
  Underground: underground ? "generate" : "skip",
  Leadins: leadins ? "generate" : "skip",
});
